import React, { Component } from "react";
import Combobox from 'react-widgets/lib/Combobox';

import 'react-widgets/dist/css/react-widgets.css';
import InputMask from "react-input-mask";
const isEmpty = require("is-empty");


class UserDetailComponent extends Component {

	///---------------------------------------INIT-------------------------------------

	state = {
		isValidNombre: false,
		nombre: '',
		errorNombre: '',

		isValidInnerBranch: false,
		innerBranch: '',
		errorInnerBranch: '',

		isValidEmail: false,
		email: '',
		errorEmail: '',

		isValidUserType: false,
		userType: '',
		errorUserType: '',

		regexp: /^[0-9\b]+$/,
		sendSMS: false,
		phoneNumber: '',
	};

	constructor(props) {
		super(props);
		this.onPressEsc = this.onPressEsc.bind(this);
		document.addEventListener('keydown', this.onPressEsc, false);
	}


	componentDidUpdate(prev) {
		if (this.props.userData) {
			if (this.props.userData !== prev.userData) {
				let newState = {
					nombre: this.props.userData.nombre,
					email: this.props.userData.email,
					userType: this.props.userData.roles[0],
					innerBranch: this.props.userData.centroFarmazon.nombre,
				}
				this.setState(newState)
			}
		}
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.onPressEsc, false);
	}

	///---------------------------------------EVENTS-------------------------------------

	onPressEsc(event) {
		if (event.keyCode === 27) {
			this.onPressCancel();
		}
	}

	validarEmail(email) {
		var emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
		if (emailRegex.test(email))
			return true
		else 
			return false
	}

	onChangeEmail(e) {
		let email = e.target.value;
		this.setState({ email })
	}

	onChangeNombre(e) {
		this.setState({
			nombre: e.target.value,
		})
	}

	clearErrors() {
		this.setState({
			errorSAP: null,
			errorMB: null,
			errorNombre: null,
			errorInnerBranch: null,
			errorEmail: null,
			errorUserType: null
		})
	}

	async preparateUpdate() {
		await this.clearErrors()
		this.validate()

		var phoneNumber = null
		if (this.state.phoneNumber) {
			phoneNumber = this.state.phoneNumber.replace("(", "")
			phoneNumber = phoneNumber.replace(")", "")
			phoneNumber = phoneNumber.replace(" ", "")
			phoneNumber = phoneNumber.replace("-", "")
		}

		if (
			this.state.isValidNombre &&
			this.state.isValidEmail &&
			this.state.isValidInnerBranch &&
			this.state.isValidUserType
		) {

			this.props.handleUpdate(
				this.props.userData._id,
				this.state.nombre,
				this.state.innerBranch,
				this.state.email,
				this.state.userType
			)

			this.farmazonFormRef.reset()
			this.nombreForm.value = null
			this.setState({
				errorNombre: '',
				errorInnerBranch: '',
				errorEmail: '',
				errorUserType: '',
				userType: '',
				innerBranch: '',
				email: '',
				nombre: '',
				phoneNumber: '',
				sendSMS: ''
			})
		}
	}

	async preparateSubmit() {
		await this.clearErrors()
		this.validate()
		if (
			this.state.isValidNombre &&
			this.state.isValidEmail &&
			this.state.isValidInnerBranch &&
			this.state.isValidUserType 
		) {
			var phoneNumber = null
			if (this.state.phoneNumber) {
				phoneNumber = this.state.phoneNumber.replace("(", "")
				phoneNumber = phoneNumber.replace(")", "")
				phoneNumber = phoneNumber.replace(" ", "")
				phoneNumber = phoneNumber.replace("-", "")
			}
			this.props.handleSubmit(
				this.state.nombre,
				this.state.innerBranch,
				this.state.email,
				this.state.sendSMS,
				phoneNumber,
				this.state.userType
			)
			this.cleanForm();
		} else if (
			this.state.isValidNombre &&
			this.state.isValidEmail &&
			this.state.isValidInnerBranch &&
			this.state.isValidUserType 
		) {
			this.props.handleSubmit(
				this.state.nombre,
				this.state.innerBranch,
				this.state.email,
				this.state.sendSMS,
				phoneNumber,
				this.state.userType,
			)
			this.cleanForm();
		}
	}

	cleanForm() {
		this.farmazonFormRef.reset()
		this.nombreForm.value = null
		this.setState({
			errorNombre: null,
			errorInnerBranch: null,
			errorEmail: null,
			errorUserType: null,
			userType: null,
			innerBranch: null,
			email: null,
			nombre: null,
			phoneNumber: null,
			sendSMS: false
		});
	}

	validate() {
		if (this.state.nombre == null || isEmpty(this.state.nombre)) {
			this.setState({
				errorNombre: "El nombre del usuario es requerido."
			})
		} else {
			this.setState({
				isValidNombre: true
			})
		}

		if (this.state.innerBranch == null || isEmpty(this.state.innerBranch)) {
			this.setState({
				errorInnerBranch: "La sucursal es requerida."
			})
		} else {
			this.setState({
				isValidInnerBranch: true
			})
		}

		if (this.state.email == null || isEmpty(this.state.email)) {
			this.setState({
				errorEmail: "El correo es requerido."
			})
		}
		if (this.state.email != null && !this.validarEmail(this.state.email)) {
			this.setState({
				errorEmail: "El correo  es inválido."
			})
		} else {
			this.setState({
				isValidEmail: true
			})
		}

		if (this.state.userType == null || isEmpty(this.state.userType)) {
			this.setState({
				errorUserType: "El tipo de usuario es requerido."
			})
		}
		else {
			this.setState({
				isValidUserType: true
			})
		}


	}

	onPressCancel() {
		this.farmazonFormRef.reset()
		this.nombreForm.value = null
		this.setState({
			errorNombre: '',
			errorInnerBranch: '',
			errorEmail: '',
			errorUserType: '',
			userType: '',
			innerBranch: '',
			email: '',
			nombre: '',
			phoneNumber: '',
			sendSMS: false
		}, () => {
			this.props.handleCancel()
		})
	}

	onChangeBranch(e) {
		this.setState({
			innerBranch: e
		})
	}

	toggleCheckboxChange(e) {
		this.setState({
			sendSMS: !this.state.sendSMS
		})
	}

	onChangePhoneNumber = (event) => {
		this.setState({
			phoneNumber: event.target.value
		});
	}

	onChangeRole(newOption) {
		this.setState({
			userType: newOption
		})
		
	}


	onDelete() {
		this.props.onDelete(this.props.userData._id)
	}

	///---------------------------------------VIEW-------------------------------------

	render() {
		var title = "CAPTURA LOS SIGUIENTES DATOS"
		if (this.props.type === 'UPDATE') {
			title = "ACTUALIZA LOS DATOS"
		}

		var defaultUserType = null
		var defaultUserTypeOnCreate = null

		if (this.props.userData) {
			
			if (this.props.userData.roles.includes('PREV'))
				defaultUserType = 'PREVENTISTA'
			else if (this.props.userData.roles.includes('B2B'))
				defaultUserType = 'CLIENTE'
		}

		return (
			<div className={this.props.isVisible ? "modal display-block" : "modal display-none"}>
				<div className="modal-user-main">
					<div className="auth-group">
						{title}
						<div className="auth-label"></div>
						<div className="auth-label"></div>
						<form ref={(el) => { this.farmazonFormRef = el }}>
							<div className="auth-label">
								Nombre del usuario
								<span className="required">*</span>
								<input
									id="nombreForm"
									ref={(el) => { this.nombreForm = el }}
									onChange={this.onChangeNombre.bind(this)}
									value={this.state.nombre}
									error={this.state.errorNombre}
									type="title"
									placeholder={this.props.userData ? this.props.userData.nombre : "Ej.: Magali Lorenzo Alamilla"}
									className="local-store-input"
								/>
							</div>
							<div className="auth-error">
								{this.state.errorNombre}
							</div>

							<div className="auth-label">
								Correo electrónico
								<span className="required">*</span>
								<input
									onChange={this.onChangeEmail.bind(this)}
									value={
										this.state.email}
									error={this.state.errorEmail}
									type="title"
									placeholder={this.props.userData ? this.props.userData.email :
										"Ej.: admin@mifarmacia.com"}
									className="local-store-input"
								/>
							</div>
							<div className="auth-error">
								{this.state.errorEmail}
							</div>

							{this.props.type !== 'UPDATE' &&
								<div className="row-multiselect-roles">
									Tipo de usuario
									<span className="required">*</span>
									<Combobox
										className="select-roles"
										data={[
											'CLIENTE', 'PREVENTISTA'
										]}
										error={this.state.errorUserType}
										defaultValue={defaultUserTypeOnCreate}
										onChange={this.onChangeRole.bind(this)}
										placeholder='Seleccione una opción'
									/>
								</div>
							}

							{defaultUserType && this.props.type === 'UPDATE' &&

								<div className="row-multiselect-roles">
									Tipo de usuario
									<span className="required">*</span>
									<Combobox
										className="select-roles"
										data={[
											'CLIENTE', 'PREVENTISTA'
										]}
										error={this.state.errorUserType}
										defaultValue={defaultUserType}
										onChange={this.onChangeRole.bind(this)}
									/>
								</div>
							}
							<div className="auth-error">
								{this.state.errorUserType}
							</div>
				
							{this.props.type !== 'UPDATE' &&
								<div className="auth-label">
									Desea enviar un mensaje SMS al usuario?
									<input
										style={{ marginLeft: "5px" }}
										type="checkbox"
										value="Desea enviar mensaje SMS?"
										checked={this.state.sendSMS}
										onChange={this.toggleCheckboxChange.bind(this)}
									/>
								</div>
							}

							{this.state.sendSMS &&
								<div className="auth-label">
									Teléfono
									<span class="required">*</span>
									<InputMask
										value={this.state.phoneNumber}
										mask="(99) 9999-9999"
										placeholder="Ej.: (55) 1234-5678"
										onChange={this.onChangePhoneNumber.bind(this)}
										className="local-store-input" />
								</div>
							}

							<div className="auth-label">Centro Farmazon
								<span className="required">*</span>
							</div>
							{this.props &&
								<div className="row-multiselect-roles">
									<Combobox
										className="select-roles"
										data={this.props.centros}
										textField='nombre'
										valueField='innerBranchId'
										filter='contains'
										defaultValue={
											this.props.type === 'UPDATE' ?
											this.props.userData != null ?
											this.props.userData.innerBranchId : null : null
										}
										value={
											this.props.type === 'UPDATE' ?
												this.state.innerBranch != null ?
												this.state.innerBranch :
												this.props.userData ? 
												this.props.userData.innerBranchId : null
												: this.state.innerBranch
										}
										placeholder="Seleccione una opción"
										onChange={this.onChangeBranch.bind(this)}
									/>
								</div>
							}
							<div className="auth-error">
								{this.state.errorInnerBranch}
							</div>

							<div className="auth-label"></div>
							<div className="auth-label"></div>
							<div className="auth-error">
								{this.props.error}
							</div>
						</form>
						<div className="modal-activity-section">
							{
								this.props.type === 'UPDATE' &&
								<button className="modal-buttonOK" onClick={this.preparateUpdate.bind(this)}>ACTUALIZAR</button>
							}
							{
								this.props.type !== 'UPDATE' &&
								<button className="modal-buttonOK" onClick={this.preparateSubmit.bind(this)}>GUARDAR</button>
							}
							{
								this.props.type === 'UPDATE' &&
								this.props.userData &&
								this.props.userData.email !== this.props.auth.user.email &&
								this.props.userData.is_active &&
								<button className="modal-buttonDelete" onClick={this.onDelete.bind(this)}>DESACTIVAR</button>
							}
							{
								<button className="modal-buttonNo" onClick={this.onPressCancel.bind(this)}>CERRAR</button>
							}
						</div>
					</div>
				</div>
			</div>
		)

	}
}

export default UserDetailComponent;
